'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.MySwiper = void 0;
const swiper_1 = require("swiper");
const swiper_2 = require("swiper");
class MySwiper {
    constructor() {
        // イメージ写真 自動切り替え
        const swiperScroll = new swiper_1.default('.bulletScrollSwiper', {
            modules: [swiper_2.Autoplay, swiper_2.EffectFade],
            allowTouchMove: false,
            loop: true,
            effect: 'fade',
            speed: 700,
            autoplay: {
                delay: 6000,
            },
        });
        // リコメンド
        const swiperRecommend = new swiper_1.default('.bulletSpecialRecommend', {
            modules: [swiper_1.Navigation, swiper_2.Autoplay],
            loop: true,
            speed: 500,
            navigation: {
                nextEl: ".trigSpecialRecommendNext",
                prevEl: ".trigSpecialRecommendPrev"
            },
            autoplay: {
                delay: 10000,
            },
            slidesPerView: 3,
            spaceBetween: 28,
        });
    }
}
exports.MySwiper = MySwiper;
exports.default = MySwiper;
